import styled from 'styled-components'

const ListItem = styled.li`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  min-height: 53px;

  &:not(:first-of-type) {
    border-top: 1px solid #ccc;
  }
`

export default ListItem
